import validate from "/codebuild/output/src1217916800/src/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_eslint@8.57.0_typescript@5.5.3_vite@5.3.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src1217916800/src/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_eslint@8.57.0_typescript@5.5.3_vite@5.3.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}